import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';
//translations
import { useTranslation } from 'react-i18next';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { cartSelector, clear } from 'slices/cart';
import { userSelector, fetchUserInfo } from 'slices/user';
//api
import { createOrder } from 'api/ecommerce';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//images
import shoppingbag from 'assets/img/ico_shoppingbag.png';
//styles
import './cart.scss';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const OkPayment = () => {
  const query = useQuery();
  const ds_merchant_parameters = query.get('Ds_MerchantParameters');
  const {t} = useTranslation(['payment']);
  const ds_signature = query.get('Ds_Signature');
  const { isNewShippingAddress, isStorePickup, items, shippingCosts, isGiftOrder, giftData, appliedCoupon } =
    useSelector(cartSelector);
  const { billingAddress, shippingAddress, benefitedBookstore, pickUpLibrary } = useSelector(userSelector);
  const [header, setHeader] = useState('');
  const [msg, setMsg] = useState('');
  const [successPayment, setSuccessPayment] = useState(true);
  const { assignedLibrary} = useAssignedLibrary();
  

  const dispatch = useDispatch();

  const confirmOrder = async () => {
    if (items.length > 0) {
      const payload = {
        payment_method: 4,
        billing_address: billingAddress,
        shipping_address: shippingAddress,
        is_new_shipping_address: isNewShippingAddress,
        store_pickup: isStorePickup,
        items,
        shipping_cost: shippingCosts,
        finish_process: true,
        is_gift: isGiftOrder,
        benefited_company: benefitedBookstore?.id,
        ds_merchant_parameters,
        ds_signature,
        applied_coupon: appliedCoupon,
      };
      if (isStorePickup) {
        payload.bookstore_to_pickup = pickUpLibrary.id;
      }
      if (isGiftOrder) {
        payload.gift_data = giftData;
      }
      try {
        const { status } = await createOrder(payload);
        if (status === 201 || status === 200) {
          setSuccessPayment(true);
          dispatch(clear());
        } else {
          setHeader(t('payment:errorocurredorder'));
          setMsg(t('payment:errorocurredordermessage'));
        }
      } catch (error) {
        setHeader(t('payment:errorocurredorder"'));
        setMsg(t('payment:errorocurredordermessage'));	
      }
    } else {
      setHeader(t('payment:emptycart'));
      setMsg(t('payment:therearentelementscart'));
    }
  };

  useEffect(() => {
    confirmOrder();
  }, []);

  useEffect(() => {
    setHeader(t('payment:inprocess'));
    setMsg(t('payment:inprocessorder'));
  },[t])

  return (
    <Container className="mainDiv">
      {successPayment ? (
        <Row className="noFavorites text-center">
          <Col lg={10} className="margin-bottom-md mt-5">
            <img src={shoppingbag} alt="bag.png" />
          </Col>
          <Col lg={8} className="margin-bottom-md container-text-ok-payment">
            <h2>{t('payment:thanksForYourPay')}</h2>
            <p>{t('payment:thanksShoppingLibelista')}</p>
            <p>{t('payment:sentemaildetailsShopping')}</p>
            <p>
              {t('payment:buyBooks')}
              <Link to={`/${assignedLibrary}/my/books`} className="">
                {' '}
                {t('payment:mybooks')}
              </Link>
              .
            </p>
            <p>{t('payment:physicalBookPurchaseMessage')}</p>
            <Link to="/" className="">
              <Button className="mt-4 p-3">{t('payment:backHome').toUpperCase()}</Button>
            </Link>
          </Col>
        </Row>
      ) : (
        <div>
          <Row>
            <Col md={12} className="title">
              <h2>{t('payment:shoppingcart')}</h2>
              <span className="divider-title"></span>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-center">
                <h3>{header}</h3>
                <p>{msg}</p>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </Container>
  );
};

export default OkPayment;
